import { useDomainContext } from "@hooks/useDomainContext";
import React, { ReactElement } from "react";
import styles from "./legal.module.scss";
import PrivacyPolicyFallback from "./fallbacks/privacyPolicyFallback";
import { formatTimestamp } from "@lib/sharedUtils";

export default function PrivacyPolicy({
    domainNameAsProp,
    categoryNameAsProp = "Auto Warranty and Car insurance",
    className,
    mainWrapperClassName,
}: {
    domainNameAsProp?: string;
    categoryNameAsProp?: string;
    className?: string;
    mainWrapperClassName?: string;
}): ReactElement {
    const {
        domain: { name: actualDomainName, niceName, textBlocks, translations },
        category,
        domainNameTranslation,
    } = useDomainContext();
    const domainName = niceName ?? actualDomainName ?? domainNameAsProp;
    const categoryName = category?.name ?? categoryNameAsProp;
    const replaceDomainName = (text: string) => {
        return text
            .replace(/{domainName}/g, domainName)
            ?.replace(/{categoryName}/g, categoryName)
            ?.replace(/{mailInfo}/g, domainName.toLowerCase());
    };
    const privacyPolicy =
        textBlocks?.find(
            (textBlock) =>
                textBlock.position === "custom-domain-privacy-policy",
        ) ||
        textBlocks?.find(
            (textBlock) =>
                textBlock.position === "custom-category-privacy-policy",
        );

    return privacyPolicy ? (
        <div
            className={`${mainWrapperClassName ?? styles["legal"]} ${
                className ?? ""
            }`}
            dangerouslySetInnerHTML={{
                __html: `
                ${
                    privacyPolicy.updatedAt
                        ? `<div class="timeStyle">${
                              translations?.[
                                  `${domainNameTranslation}_LastUpdated`
                              ] ?? "Last Updated:"
                          } ${formatTimestamp(privacyPolicy.updatedAt)}</div>`
                        : ""
                }
                ${replaceDomainName(privacyPolicy.text)}`,
            }}
        />
    ) : (
        <PrivacyPolicyFallback
            domainName={domainName}
            categoryName={categoryName}
            className={className}
            mainWrapperClassName={mainWrapperClassName}
        />
    );
}
